$('a[href]').each(function () {
    var linkHost = new URL(this.href).hostname;
    var currentHost = location.hostname;

    if (linkHost && linkHost !== currentHost) {
      $(this).attr('target', '_blank');
    }
  });
$(".special__items").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 10000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
  infinite: true
});


$(".review__items").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
});




// testimonial start

$(".testimonial__items").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
    },
  }, ],
});



// testimonial end



// got-more start


$(".got-more__video").click(function () {
  var video = $(this).find("video").get(0);
  var icon_image = $(this).find(".got-more__video-play-icon");
  if (video.paused) {
    $("video").each(function () {
      this.pause();
      $(".got-more__video-play-icon").css("display", "block");
    });
    video.play();
    icon_image.css("display", "none");
  } else {
    video.pause();
    icon_image.css("display", "block");
  }
});



$('.story-hero__video-icon a').click(function (e) {
  e.preventDefault();
  myVIdeo = myVIdeo + $(this).attr('href');
  $('.video-pop').addClass('show-video');
  $('.video-pop iframe').attr('src', myVIdeo);
});
$('.video-btn').click(function (e) {
  e.preventDefault();
  var newVideo = $(this).attr('href');
  
  $('.video-pop').addClass('show-video');
  if (newVideo.includes("https://")) {
      $('.modal-video').attr("src", newVideo)[0].play();
      $('.modal-video').css('display', 'block');
      $('#existing-iframe-example').css('display', 'none');
  }else{
      $('.modal-video').css('display', 'none');
      $('#existing-iframe-example').css('display', 'block');
      myVIdeo = myVIdeo + $(this).attr('href');
      $('.video-pop iframe').attr('src', myVIdeo);
  }
  
})

// $('.single__product-video-thumb').click(function (e) {
//   e.preventDefault();
//   myVIdeo = myVIdeo + $(this).attr('href');
//   $('.video-pop').addClass('show-video');
//   $('.video-pop iframe').attr('src', myVIdeo);
// })



// $(document).ready(function () {
// //   var videoPlayed = false; // Flag to track if the video has played

//   $(".single__product-video-thumb").on("click", function () {
//       var section = $(".got-more__video");
//       var video = section.find("video")[0]; 
//       var playIcon = $(".got-more__video-play-icon");

//       section.show(); 

//       if (videoPlayed) {
//           video.currentTime = 0; 
//           videoPlayed = false;
//           playIcon.show();
//       }

//       function playPauseVideoOnVisibility() {
//           var windowHeight = $(window).height();
//           var scrollTop = $(window).scrollTop();
//           var sectionOffset = section.offset().top;
//           var sectionHeight = section.outerHeight();

//           if (scrollTop + windowHeight > sectionOffset && scrollTop < sectionOffset + sectionHeight) {
//               if (video && video.paused && !videoPlayed) {
//                   video.play(); 
//                   playIcon.hide(); 
//                   videoPlayed = true; 
//               }
//           } else {
//               if (video && !video.paused) {
//                   video.pause(); 
//                   playIcon.show(); 
//               }
//           }
//       }

//       $(window).on("scroll", playPauseVideoOnVisibility);
//       playPauseVideoOnVisibility();
//   });
// });




$(document).ready(function () {
  $(".single__product-video-thumb").on("click", function () {
  var videoPlaying = false;
  var section = $(".got-more__video");
  var iframe = section.find("iframe.got-more__video-main");
  var originalSrc = iframe.attr("src").split("?")[0]; // Store original video URL
  
    // section.show(); 
    // if (!videoPlaying) {
    //   var newSrc = originalSrc + "?autoplay=1&mute=0&controls=0"; // Enable autoplay with sound and disable controls
    //   iframe.attr("src", newSrc); // Set the new src to start the video
    //   videoPlaying = true; // Mark the video as playing
    //   console.log("Video Started:", newSrc);
    // }
  // Pause video when out of view
  function checkVideoVisibility() {
    var windowHeight = $(window).height();
    var scrollTop = $(window).scrollTop();
    var sectionOffset = section.offset().top;
    var sectionHeight = section.outerHeight();

    if (scrollTop + windowHeight > sectionOffset && scrollTop < sectionOffset + sectionHeight) {
      if (!videoPlaying) {
        var newSrc = originalSrc + "?autoplay=1&mute=0&controls=0"; 
        iframe.attr("src", newSrc);
        videoPlaying = true;
        console.log("Video Started:", newSrc);
        
      }
    } else {
      if (videoPlaying) {
        var newSrc = originalSrc + "?autoplay=0&mute=0&controls=0"; 
        iframe.attr("src", newSrc);
        videoPlaying = true;
        console.log("Video Stopped");
        
      }
    }
  }

  // Check on scroll
  $(window).on("scroll", checkVideoVisibility);

});
});





// marquee start


$(".marquee__items").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false
});


// marquee end






$(document).ready(function () {
  // Flag to check if the images have already been shown
  let imagesShown = false;

  function checkViewport() {
      if (imagesShown) return;  

      $(".snackdown").each(function () {
          let elementTop = $(this).offset().top;
          let elementBottom = elementTop + $(this).outerHeight();
          let viewportTop = $(window).scrollTop();
          let viewportBottom = viewportTop + $(window).height();

          // Check if the element is in the viewport
          if (elementBottom > viewportTop && elementTop < viewportBottom) {
              var find_main_img = $(this).find(".snackdown__img-wrap img");

              // Loop through each image and apply the 'visible' class one by one
              find_main_img.each(function(index) {
                  $(this).delay(index * 50).queue(function(next) {
                      $(this).addClass('visible');
                      next();
                  });
              });

              // Set the flag to true to prevent it from running again
              imagesShown = true;
              $(window).off("scroll resize", checkViewport); 
          }
      });
  }

  checkViewport(); 
  $(window).on("scroll resize", checkViewport); 
});



















// landing js start here 


// text-with-video start


document.addEventListener("DOMContentLoaded", function () {
  const videoContainer = document.querySelector(".text-with-video__video");
  const video = videoContainer.querySelector("video");
  const playBtn = videoContainer.querySelector(".text-with-video__play-btn");

  function toggleVideo() {
      if (video.paused) {
          video.play();
          playBtn.style.display = "none";
      } else {
          video.pause();
          playBtn.style.display = "block";
      }
  }

  playBtn.addEventListener("click", toggleVideo);
  video.addEventListener("click", toggleVideo);
});



(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAudioPlayer);
  } else {
    initAudioPlayer(); // DOM already ready, run immediately
  }

  function initAudioPlayer() {
    const voiceBlock = document.querySelector('.landing-hero__voice');
    const audio = document.getElementById('ollys-audio');
    const text = voiceBlock.querySelector('p');
    const timeDisplay = voiceBlock.querySelector('.landing-hero__voice-time');
    let countdownInterval;

    function formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    function updateDurationDisplay() {
      if (!isNaN(audio.duration)) {
        timeDisplay.textContent = formatTime(audio.duration);
      }
    }

    audio.addEventListener('loadedmetadata', updateDurationDisplay);

    voiceBlock.addEventListener('click', function () {
      if (audio.paused || audio.ended) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      text.classList.add('audio-play');
      voiceBlock.classList.add('border-change');
      clearInterval(countdownInterval);
      countdownInterval = setInterval(function () {
        const timeLeft = Math.max(0, audio.duration - audio.currentTime);
        timeDisplay.textContent = formatTime(timeLeft);
      }, 1000);
    });

    function stopPlaybackEffects() {
      text.classList.remove('audio-play');
      voiceBlock.classList.remove('border-change');
      clearInterval(countdownInterval);
    }

    audio.addEventListener('pause', stopPlaybackEffects);
    audio.addEventListener('ended', function () {
      stopPlaybackEffects();
      updateDurationDisplay();
    });

    if (audio.readyState >= 1) {
      updateDurationDisplay();
    } else {
      audio.load();
    }
  }
})();



// text-with-video end


// rellex remove phone device 

$(".olive-haters-support-group .landing-hero__marquee-text").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
          },
      },
  ],
});

$(".hotline .landing-hero__marquee-text").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
          },
      },
  ],
});





$(window).on('load', function () {
  if ($(window).width() > 768) {
    $('.text-with-video__pretzel-left, .text-with-video__pretzel-right')
      .addClass('rellax')
      .attr('data-rellax-speed', '1')
      .attr('data-rellax-percentage', '0.5');
    
    var rellax = new Rellax('.rellax');
  }
});

// if (window.innerWidth > 768) {
//   var rellax = new Rellax('.rellax');
// }




// document.addEventListener("DOMContentLoaded", function () {
//   const voiceBlock = document.querySelector('.landing-hero__voice');
//   const audio = document.getElementById('ollys-audio');
//   const text = voiceBlock.querySelector('p');
//   const timeDisplay = voiceBlock.querySelector('.landing-hero__voice-time');
//   let countdownInterval;

//   // Format seconds as mm:ss
//   function formatTime(seconds) {
//       const mins = Math.floor(seconds / 60);
//       const secs = Math.floor(seconds % 60);
//       return `${mins}:${secs.toString().padStart(2, '0')}`;
//   }

//   // Set duration once audio metadata is available
//   function updateDurationDisplay() {
//       if (!isNaN(audio.duration)) {
//           timeDisplay.textContent = formatTime(audio.duration);
//       }
//   }

//   audio.addEventListener('loadedmetadata', updateDurationDisplay);

//   voiceBlock.addEventListener('click', function () {
//       if (audio.paused || audio.ended) {
//           audio.play();
//       } else {
//           audio.pause();
//       }
//   });

//   audio.addEventListener('play', function () {
//       text.classList.add('audio-play');
//       voiceBlock.classList.add('border-change'); // ✅ Add gradient border
//       clearInterval(countdownInterval);

//       countdownInterval = setInterval(function () {
//           const timeLeft = Math.max(0, audio.duration - audio.currentTime);
//           timeDisplay.textContent = formatTime(timeLeft);
//       }, 1000);
//   });

//   function stopPlaybackEffects() {
//       text.classList.remove('audio-play');
//       voiceBlock.classList.remove('border-change'); // ✅ Remove gradient border
//       clearInterval(countdownInterval);
//   }

//   audio.addEventListener('pause', stopPlaybackEffects);
//   audio.addEventListener('ended', function () {
//       stopPlaybackEffects();
//       updateDurationDisplay();
//   });

//   if (audio.readyState >= 1) {
//       updateDurationDisplay();
//   } else {
//       audio.load();
//   }
// });



// landing-hero__voice end




// landing-marquee__inner start


$(".landing-marquee__items").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  variableWidth: true,
  arrows: false,
  pauseOnHover: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
          },
      },
  ],
});

$(".support__items").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});




// landing-marquee__inner end









// landing js end here 